export default "__VITE_ASSET__DYAoih$n__"